// Fixed Lyft Arkansas "Vehicle Inspection" checklist points (19 total),
// matching the official Lyft Arkansas form. Column split: 1-12 left, 13-19 right.
// Point 17 (Tires) renders four sub-items that share the tire check's status.

export const lyftArkansasInspectionPoints = [
  { number: 1, label: "Foot brakes" },
  { number: 2, label: "Emergency brake (parking brake)" },
  { number: 3, label: "Steering mechanism" },
  { number: 4, label: "Windshield" },
  { number: 5, label: "Rear window and other glass" },
  { number: 6, label: "Windshield wipers" },
  { number: 7, label: "Headlights" },
  { number: 8, label: "Tail lights" },
  { number: 9, label: "Turn indicator lights" },
  { number: 10, label: "Stop Lights" },
  { number: 11, label: "Front seat adjustment mechanism" },
  { number: 12, label: "Doors (open, close, unlock)" },
  { number: 13, label: "Horn" },
  { number: 14, label: "Speedometer" },
  { number: 15, label: "Bumpers" },
  { number: 16, label: "Muffler and exhaust system" },
  {
    number: 17,
    label: "Tires, incl. tread depth",
    subItems: ["Left front", "Right front", "Left rear", "Right rear"],
  },
  { number: 18, label: "Interior and exterior rear view mirrors" },
  { number: 19, label: "Safety belts for driver and passenger(s)" },
];

export const lyftArkansasColumns = [
  lyftArkansasInspectionPoints.slice(0, 12),
  lyftArkansasInspectionPoints.slice(12),
];

// Resolves PASS/FAIL for a point from the inspection checks (mapped by index).
export const getLyftArkansasPointStatus = (checksData, index) => {
  const status = checksData?.[index]?.status;
  return {
    pass: status === true || status === 1,
    fail: status === false || status === 0,
  };
};
